import { Injectable } from '@angular/core';
import { ApiService } from './api-service';
import { CalendarioEventi } from 'src/app/models/calendarioeventi';
import { UrlSerializer, Router } from '@angular/router';
import { ConstantsStore } from './constants.store';
import { CalendarioEventiPrivati } from 'src/app/models/calendario-eventi-privati';
import { TopFlopAll } from 'src/app/models/TopFlopAll';
import { Matrice, SubMatrice } from '../../models/matrice';
import { MatriceSearch } from '../../models/MatriceSearch';

@Injectable({
  providedIn: 'root'
})
export class TableService {

  constructor(
    private api: ApiService,
    private router: Router,
    private serializer: UrlSerializer,
    private constants: ConstantsStore
  ) { }


  // * CalendarioEventi
  public getCalendarioEventiRecords(date: Date) {
    const jsonDate = date.toJSON();
    return this.api.getTableRecordsNoCacheBasic<CalendarioEventi[]>(this.constants.calendarioEventiUrl + '/' + jsonDate);
  }

  public getCalendarioEventiPrivatiRecords() {
    return this.api.getTableRecordsNoCacheBasic<CalendarioEventiPrivati[]>(this.constants.calendarioEventiPrivatiUrl);
  }


  // * TopFlop
  public getTopFlopRecords(pageNumber: number, pageSize: number, filter: string, ascending: boolean) {
    const filterQueryString = (filter != null) ? ('/' + filter) : '';
    const ascendingQueryString = (filter != null && ascending != null) ? ('/' + ascending) : '';
    return this.api.getTableRecords<TopFlopAll>(this.constants.topFlopUrl + '/' + pageNumber + '/' + pageSize + filterQueryString + ascendingQueryString);
  }


  // * Matrice
  public getMatrice() {
    return this.api.getMatrice<Matrice>(this.constants.matriceUrl);
  }

  public getSubMatriceRecords(sottostantecode: string, pageNumber: number, pageSize: number) {
    return this.api.getSubMatrice<SubMatrice>(this.constants.matriceUrl + '/' + pageNumber + '/' + pageSize, sottostantecode);
  }

  public getSubMatriceSearchResult(obj: MatriceSearch, pageNumber: number, pageSize: number) {
    // console.log('3) Table service -> search params', obj);
    const tree = this.router.createUrlTree([''], { queryParams: obj });
    // console.log('4) Table service -> serialized params', this.serializer.serialize(tree));
    return this.api.getTableRecords<MatriceSearch>(
      this.constants.subMatriceSearchUrl + '/' + pageNumber + '/' + pageSize + this.serializer.serialize(tree)
    );
  }

  public getIsinListBySottostante(filters: MatriceSearch) {
    const urlParamsTree = this.router.createUrlTree([''], { queryParams: filters });
    return this.api.get<MatriceSearch[]>(`${this.constants.subMatriceSearchUrl}${this.serializer.serialize(urlParamsTree)}`);
  }


  /* AdvancedSearch */

  // getAdvancedSearchTableRecords(pageNumber: number, pageSize: number, obj: AdvancedSearchResult, filter: string, ascending: boolean) {
  //   const filterQueryString = (filter != null) ? ('/' + filter) : '';
  //   const ascendingQueryString = (filter != null && ascending != null ) ? ('/' + ascending) : '';

  //   const test: any = obj;
  //   test.scadenzaDa = test.scadenzaDa != null ? test.scadenzaDa.toJSON() : null;
  //   test.scadenzaA = test.scadenzaA != null ? test.scadenzaA.toJSON() : null;

  //   const tree = this.router.createUrlTree([''], { queryParams: obj });

  //   return this.api.getTableRecords<AdvancedSearchResult>(
  //     this.constants.advancedSearchUrl + '/' + pageNumber + '/' + pageSize + filterQueryString + ascendingQueryString + this.serializer.serialize(tree)
  //   );
  // }

  // getDropdownValues() {
  //   return this.api.get<{[key: string]: string}>(
  //     this.constants.dropdownValuesUrl
  //   );
  // }

  // getAutocompleteValues() {
  //   return this.api.get<{[key: string]: string}>(
  //     this.constants.autocompleteValuesUrl
  //   );
  // }



  /* Portafoglio */

  // getDefaultPortafoglioRecords() {
  //   return this.api.getTableRecordsNoCacheBasic<PortafoglioRecord[]>(this.constants.portafoglioUrl);
  // }

  // getPortafoglioRecords(portafoglioId: number) {
  //   return this.api.getTableRecordsNoCacheBasic<PortafoglioRecord[]>(this.constants.portafoglioUrl + '/' + portafoglioId);
  // }

  // postPortafoglioRecord(toAdd: PortafoglioPostData) {
  //   return this.api.post(this.constants.portafoglioUrl, toAdd);
  // }

  // deleteIsinFromPortafoglio(portafoglioId: number, isin: string) {
  //   return this.api.deleteIsin(this.constants.portafoglioUrl + '/' + portafoglioId, isin);
  // }



  /* Watchlist */

  // getDefaultWatchlistRecords() {
  //   return this.api.getTableRecordsNoCacheBasic<WatchlistRecord[]>(this.constants.watchlistUrl);
  // }


  // getWatchlistRecordsGuest(watchlistId: number) {
  //   return this.api.getTableRecordsNoCacheBasic<WatchlistRecord[]>(this.constants.watchlistUrl + '/guest/' + watchlistId);
  // }

}
